import $ from 'jquery';

const langNavigation = () => {
    // Language Navigation
    $('.s-mobile-header .c-language-selector > a')
        .on('click', e => {
            e.preventDefault();

            $(e.target).next('.dropdown-menu').slideToggle();
        });
};

// doc ready
$(() => {
    langNavigation();
});



// WEBPACK FOOTER //
// ./src/components/mobile-header/utility-links/c-utility-links.js